<template>
  <div>
    <b-modal id="bv-modal-example" centered hide-footer>
      <template #modal-title> Palestrante </template>
      <div class="d-block text-center">
        <h3>Fulano da Silva</h3>
      </div>
    </b-modal>

    <div class="bg-bege">
      <div class="container-ifgo">
        <Capa />
      </div>
    </div>

    <Palestrantes />

    <Evento />

    <Evento2 />

    <!--<Secao titulo="games" id="games">
      <div class="row">
        <div class="col-12">
          <div class="video_wrapper">
            <iframe
              width="100%"
              height="500"
              src="https://www.youtube.com/embed/JjUDvLzPDj0"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>

        <div class="col-md-5">
          <img
            src="@/assets/imgs/layout/game-controller.png"
            class="img-fluid"
            alt="Controle de videogame"
          />
        </div>
        <div class="col-md-7">
          <h4>Participe do Campeonato de Games do ENATI</h4>
          <p>
            Se você gosta de jogar, não pode perder o Campeonato de Games do
            ENATI. A atividade acontecerá no sábado, das 8h às 12h, com
            diferentes modalidades. Confira o regulamento de cada modalidade e
            faça a sua inscrição:
          </p>
          <div class="d-grid gap-2 mt-4 mb-4">
            <a
              href="pdfs/Regulamento-LeagueofLegends.pdf"
              target="_blank"
              class="btn btn-outline-light"
              >League of Legends</a
            >
            
            <a
              href="pdfs/Regulamento-JustDance.pdf"
              target="_blank"
              class="btn btn-outline-light"
              >Just Dance</a
            >
            <a
              href="pdfs/Regulamento-FreeFire.pdf"
              target="_blank"
              class="btn btn-outline-light"
              >Free Fire</a
            >
            <a
              href="pdfs/Regulamento-AmongUs.pdf"
              target="_blank"
              class="btn btn-outline-light"
              >Among Us</a
            >
          </div>
        </div>
      </div>
    </Secao>-->

    <Programacao />

    <Local />
  </div>
</template>

<script>
import Capa from "@/components/layout/Capa";
//import Secao from "@/components/layout/Secao.vue";

import Evento from "@/components/Home/Evento.vue";
import Evento2 from "@/components/Home/Evento2.vue";
import Palestrantes from "@/components/Home/Palestrantes.vue";
import Local from "@/components/Home/Local.vue";
import Programacao from "@/components/Home/Programacao.vue";


export default {
  name: "App",
  components: {
    Capa,
    Evento,
    Evento2,
    //Secao,
    Palestrantes,
    Programacao,
    Local,
},

  data() {
    return {
      carregando: true,
      hash: this.$route.hash,
    };
  },

  mounted() {
    this.$nextTick(function () {
      if (this.hash) {
        const refName = this.hash.replace("#", "");
        this.scrollToAnchorPoint(refName);
      }
    });
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName];
      el.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss">
$corPrincipal: #ee6d3d;
:root {
  --corFundo: #fff;
  --corFundoIntercalado: #063342;
  --corTexto: #000;
  --corPrincipal: #24667b;
  --corSecundaria: #2b6c81;
  /*  --begeCor: #f9ffff; */
  --begeCor: #dfeaed;
  --bege: linear-gradient(180deg, #dfeaed 0%, #fff 100%);
  --fundoRodape: #fff;
  --cardHeader: #fff;
  --cardBody: #f4f9f9;
  --programacao: #fff;
  --sombra: 0 5px 10px -2px rgb(69 67 96 / 7%);
}

@import url("../assets/css/reset.css");

@import url("../assets/scss/card.scss");

@import url("../assets/scss/scroll.scss");

a {
  text-decoration: none;
}

b {
  font-weight: bold;
}
html {
  scroll-behavior: smooth;
}

.btn {
  font-family: "Barlow";
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 46px !important;
}

.btn-warning {
  background: linear-gradient(-60deg, #ff5858 0%, #f09819 100%);
  border: none !important;
  background-size: 1px 150px;
  padding: 7px 21px;
  border-radius: 46px;
  -webkit-transition: background 0.5s ease-out;
  -moz-transition: background 0.5s ease-out;
  -o-transition: background 0.5s ease-out;
  transition: background 0.5s ease-out;
  color: #fff !important;
  font-family: "Barlow";
}

section {
  p {
    font-family: "Barlow";
  }
  padding: 120px 0px;
  background: var(--corFundo);
  color: var(--corTexto);
  &:first-child {
    background: orange;
  }
  &:nth-child(odd) {
    background: var(--bege);
  }
  header.container-ifgo {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 90px;
    flex-wrap: nowrap;
  }
  header {
    h3 {
      font-size: 2.6rem !important;
      color: var(--corTexto);
      margin-bottom: 0px;
      background-image: linear-gradient(-20deg, #fc6076 0%, #ff9a44 100%);
      background-image: linear-gradient(
        60deg,
        #24667b 0%,
        #24667b 37%,
        #2cacd1 65%,
        #35eb93 100%
      );
      background-image: linear-gradient(
        60deg,
        #3d3393 0%,
        #2b76b9 37%,
        #2cacd1 65%,
        #35eb93 100%
      );
      background-image: linear-gradient(-60deg, #ff5858 0%, #f09819 100%);
      font-weight: 900;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    hr {
      background: #222 !important;
      background: var(--corPrincipal);
      display: flex;
      flex: 1 1 auto;
      margin-left: 2rem;
      border-width: 0px;
      height: 1px;
      border-style: solid;
    }
  }
  .codigo {
    color: var(--corPrincipal);
  }
}
h4 {
  font-family: "Barlow";
  font-style: normal;
  font-weight: 100;
  font-size: 30px;
  line-height: 39px;
  font-family: "Barlow", sans-serif;
}

.bg-bege {
  background: var(--bege);
}

section {
  ul {
    //list-style: initial;
    li {
      font-size: 1.1rem;
      line-height: 1.5;
    }
    li::before {
      content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
      color: #ff9a44; /* Change the color */
      font-weight: bold; /* If you want it to be bold */
      display: inline-block; /* Needed to add space between the bullet and the text */
      width: 1em; /* Also needed for space (tweak if needed) */
      margin-left: -1em; /* Also needed for space (tweak if needed) */
    }
  }
}

#games iframe {
  border-radius: 20px;
  margin-bottom: 80px;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}

.video_wrapper {
  width: 100%;
  padding: 56.25% 0px 0px;
  position: relative;
  margin-bottom: 4rem;
}

ul,
li {
  font-family: "Barlow";
}
button.btn-outline-warning {
  font-family: "JetBrains Mono" !important;
  text-transform: uppercase !important;
  color: var(--corPrincipal) !important;
  border-color: var(--corPrincipal) !important;
  &:hover {
    color: #fff !important;
    background-color: var(--corPrincipal) !important;
  }
}
span.destaque {
  font-weight: 500;
}
h1 {
  font-family: "Barlow", sans-serif;
}
h2 {
  font-family: "Barlow", sans-serif;
}
h3 {
  font-family: "Barlow", sans-serif;
  font-family: "JetBrains Mono", monospace;
  font-size: 40px !important;
  margin: 0px;
  font-weight: 700;
}
h5 {
  font-family: "Barlow", sans-serif;
}
h6 {
  font-family: "Barlow", sans-serif;
}
p {
  font-family: "Barlow", sans-serif;
  font-size: 1.1rem;
  line-height: 1.2;
  margin: 1rem 0rem;
}
body {
  background-color: var(--corFundo) !important;
  color: var(--corTexto) !important;
  font-family: "Barlow", sans-serif;
  background-attachment: fixed;
}
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.container-ifgo {
  max-width: 1216px;
  margin: 0 auto;
  padding: 15px;
}
.d-flex {
  display: flex;
}
.justify-content-between {
  justify-content: space-between;
}
.negrito {
  font-weight: 700;
}
.laranja {
  color: var(--corPrincipal);
}
.azul {
  color: var(--corSecundaria);
}
.h3 {
  font-family: "JetBrains Mono", monospace;
  font-size: 40px !important;
  margin: 0px;
  font-weight: 700;
}

#games {
  background: #063342;
  color: #fff;
}

@media screen and (max-width: 700px) {
  h3 {
    font-size: 30px !important;
  }
  #local {
    div {
      text-align: center;
      margin: 10px 0px;
    }
  }
}
</style>
